
// apply discount code on product page
(function () {
    if (document.body.classList.contains('template_product') && document.querySelector('.product__discount_code')) {
        let discountCodeContainer = document.querySelectorAll('.product__discount_code')
        

        let clearBtn = document.querySelector("#clear-discount-btn");
        let applyBtn = document.querySelector("#apply-discount-btn");
        let discountCodeError = document.querySelector("#discount-code-error");
        let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
        let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
        let discountCodeInput = document.querySelector("#discount-code-input");
        let totalCartSelector = document.querySelector(".cart__subtotal .money"); // Total Cart Selector to update the total amount. 
        let authorization_token;
        
        let checkoutContainer = document.createElement('div');
        document.body.appendChild(checkoutContainer);

        if (localStorage.discountCode) applyDiscount( JSON.parse(localStorage.discountCode).code);

        discountCodeContainer.forEach(el => {
          el.addEventListener('click' , () => {
            let discountCode = el.dataset.code
            applyDiscount(discountCode);
        })
        })
        function clearLocalStorage() {
          localStorage.removeItem("discountCode");
        }
        function applyDiscount(code, el) {
          fetch("/payments/config", {"method": "GET"})
          .then(function(response) { return response.json() })
          .then(function(data) {
              const checkout_json_url = '/wallets/checkouts/';
              authorization_token = btoa(data.paymentInstruments.accessToken)
              fetch('/cart.js', {}).then(function(res){return res.json();})
              .then(function(data){
              let body = {"checkout": { "country": Shopify.country,"discount_code": code,"line_items": data.items, 'presentment_currency': Shopify.currency.active } }
              fetch(checkout_json_url, {
                "headers": {
                  "accept": "*/*", "cache-control": "no-cache",
                  "authorization": "Basic " + authorization_token,
                  "content-type": "application/json, text/javascript",
                  "pragma": "no-cache", "sec-fetch-dest": "empty",
                  "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
                },
                "referrerPolicy": "strict-origin-when-cross-origin",
                "method": "POST", "mode": "cors", "credentials": "include",
                "body": JSON.stringify(body)
            })
            .then(function(response) { return response.json() })
            .then(function(data) {
              if(data.checkout && data.checkout.applied_discounts.length > 0){
                let discountApplyUrl = "/discount/"+code+"?v="+Date.now()+"&redirect=/checkout/";
                fetch(discountApplyUrl, {}).then(function(response) { return response.text(); })
                let localStorageValue = {
                  'code': code.trim(),
                  'totalCart': data.checkout.total_line_items_price
                };
                localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
                if(totalCartSelector) totalCartSelector.innerHTML = "<s>" + data.checkout.total_line_items_price + "</s>" + data.checkout.total_price;
              }else{
                if(discountCodeValue) discountCodeValue.innerHTML = "";
                clearLocalStorage();
                if(discountCodeError) discountCodeError.innerHTML = "Please Enter Valid Coupon Code."
              }
            })
            .catch((e) => console.error(e))
            .finally(function(params) {
              discountCodeContainer.forEach(el => {
                el.classList.add('active')
              })
          });
          });
        });
      }
    }
})();
// apply discount code on product page


// see it action button on product gallery
(function () {
  
    const buttons = document.querySelectorAll('.product__gallery_action')
    if (buttons) {
      window.onload = () => {
  
        buttons.forEach(button => {
          button.addEventListener('click', () => {
            if (window.innerWidth > 1023) {
              const container = document.querySelector('.product-media-container.media-type-video .deferred-media__poster')

              container.click()
              const video = document.querySelector('.slideshow.product__media-list video')

              if (video.requestFullscreen) {
                video.requestFullscreen();
              } else if (video.webkitRequestFullscreen) { // Safari
                video.webkitRequestFullscreen();
              }
              
              video.play();
            } else {
              const container = document.querySelector('.slider--mobile .product-media-container.media-type-video .product__media-toggle')
              const popupVideo = document.querySelector('.product-media-modal__dialog .deferred-media__poster')
              container.click()
              popupVideo.click()
              const video = document.querySelector('.product-media-modal__dialog video')
              
              video.play();
            }
            
        })
        })
      }    
    }
  })();
  // see it action button on product gallery


// sticky product button
(function () {
    document.addEventListener('DOMContentLoaded', function() {
      const productInfo = document.querySelector('.product-form__submit');
      const fixedButton = document.querySelector('.sticky_product_button');
      if (productInfo) {
        const calcScroll = () => {
          const productInfoRect = productInfo.getBoundingClientRect();
          const productInfoBottomVisible = productInfoRect.bottom > 0 && productInfoRect.top < window.innerHeight;
  
          if (!productInfoBottomVisible) {
              fixedButton.classList.add('show');
          } else {
              fixedButton.classList.remove('show');
          }
        }
        window.addEventListener('scroll', function() {
          calcScroll()
        });
        calcScroll()
      }
      
    });
  })();
  // sticky product button